module.exports = __webpack_public_path__ + "img/medicines.bb8506a9.svg";